<template>
  <div :id="componentId" class="how-to-use-block">
    <h1 v-animate-onscroll.repeat="{ down: 'animated fadeInUpBig' }" class="main-heading">
      {{ imageBlockData.title }}
    </h1>
    <p class="description" v-html="imageBlockData.subtitle"></p>
    <div v-for="(step, stepIndex) in imageBlockData.HowToUseSteps" :key="stepIndex">
      <div v-animate-onscroll.repeat="{ down: 'animated fadeInUpBig' }" class="title">
        {{ step.stepTitle }}
        <div class="step-number">{{ step.stepNumber }}</div>
      </div>
      <p v-animate-onscroll.repeat="{ down: 'animated fadeInUpBig' }" class="description">
        {{ step.stepDescription }}
      </p>
      <div v-if="step.stepImage">
        <img
          v-animate-onscroll.repeat="{ down: 'animated zoomIn' }"
          class="step-image"
          :src="step.stepImage"
          :alt="step.stepImageAlt"
        />
        <div v-if="step.description_section" :class="descriptionBlockStyle(step)">
          <slot :name="step.blockId"></slot>
        </div>
      </div>
      <slot v-else name="text-description"></slot>
      <div
        v-if="step.stepVideo"
        v-animate-onscroll.repeat="{ down: 'animated fadeInUpBig' }"
        class="video-block"
      >
        <videoplayer
          :src="step.stepVideo"
          :loop="step.isVideoLoop"
          :play-pause="!step.isVideoLoop"
          :autoplay="step.isVideoLoop"
          ratio="1by1"
        ></videoplayer>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'how-to-use-block',
  props: {
    imageBlockData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      componentId: 'how-to-use',
    };
  },
  mounted() {
    document.addEventListener('scroll', this.menuHighlight);
  },
  methods: {
    menuHighlight() {
      const componentBlock = document.getElementById(this.componentId);
      if (componentBlock) {
        const checkOffset = componentBlock.offsetTop - 120;
        if (window.pageYOffset >= checkOffset) {
          window.eventBus.$emit('summary-menu-highlight', this.componentId);
        }
      }
    },
    descriptionBlockStyle(step) {
      const bgcolor = step.isBgDescriptionWhite ? 'desc-white-bg' : 'desc-grey-bg';
      const overlap = step.descriptionNotOverlap
        ? 'product-desc-non-overlap'
        : 'product-desc-block-overlap';
      return `${overlap}  ${bgcolor}`;
    },
  },
};
</script>
